import './gmap-area-handler.js';
import './search-area.js';